
import { defineComponent, computed, getCurrentInstance, PropType } from 'vue';
import VueClamp from 'vue-clamp';
import { Feed } from '@/api/feed';
import { FeedPageEnum } from '@/store/modules/feed';
import Muted from './unmuted.vue';
import { getTemplateConfig } from './template.config';

const VideoInfo = defineComponent({
    components: {
        VueClamp,
        Muted,
    },

    props: {
        photoId: {
            type: String,
            default: '',
        },
        feedPage: {
            type: String as PropType<FeedPageEnum> | undefined,
            default: FeedPageEnum.PwaShareNew,
        },
    },

    setup(props) {
        const { proxy } = getCurrentInstance() || {};

        const feedList = computed<Feed[]>(() => {
            const { feedListOrigin } = proxy?.$store?.state?.feedMoudle || {};
            return feedListOrigin?.[props?.feedPage] || [];
        });

        const feed = computed(() => {
            const feedItem = feedList.value.find(item => item.photo_id_str && item.photo_id_str === props?.photoId);

            return feedItem;
        });

        const isMuted = computed<Feed[]>(() => {
            const { isMuted } = proxy?.$store?.state?.feedMoudle || {};
            return isMuted;
        });

        const handleViewUser = async () => {
            if (!feed?.value?.kwai_id) {
                return;
            }
            proxy?.$router?.push?.({ path: `/@${feed?.value?.kwai_id}` });
        };

        const handleUnmuted = () => {
            proxy?.$store?.commit?.('feedMoudle/setMuted', false);
        };

        return {
            feed,
            isMuted,
            handleViewUser,
            handleUnmuted,

            templateConfig: getTemplateConfig(),
        };
    },
});

export default VideoInfo;
